export default __webpack_public_path__ + "static/media/mp1.5996b1c2.png";